// @flow
// matches the values of $grid-breakpoints in
// styles/themes/default/_variables.scss
export const APP_BREAKPOINTS = Object.freeze({
  XS: 576,
  SM: 768,
  MD: 940,
  LG: 1200
});

export const APP_SIZES = Object.freeze({
  /* defined in variables.scss as $container-truncate-max-content-height */
  MAX_HEIGHT_TIME_SELECTOR: 142
});

// from https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
export const IS_MOBILE = window.navigator.userAgent.indexOf('Mobi') > -1;
// the value of channel depends on the app running in a mobile device (desktop = 2, mobile = 3)
export const CHANNEL = IS_MOBILE ? 3 : 2;
export const WHOAMI = 'CP8';



// WEBPACK FOOTER //
// ./src/constants/appConfig.js